/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DataImport,
  DataImportFileType,
  DataImportRow,
  DataImportRowChangeType,
  DataImportStatus,
  DataImportTagResponse,
  ErrorResponse,
  SortDirection,
} from '../models/index';
import {
    DataImportFromJSON,
    DataImportToJSON,
    DataImportFileTypeFromJSON,
    DataImportFileTypeToJSON,
    DataImportRowFromJSON,
    DataImportRowToJSON,
    DataImportRowChangeTypeFromJSON,
    DataImportRowChangeTypeToJSON,
    DataImportStatusFromJSON,
    DataImportStatusToJSON,
    DataImportTagResponseFromJSON,
    DataImportTagResponseToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/index';

export interface GetImportRequest {
    id: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetImportDetailsRequest {
    id: string;
    customerId: string;
    changeType?: DataImportRowChangeType;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetImportTagsRequest {
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface SearchImportsRequest {
    customerId: string;
    fileName?: string;
    fileTypes?: Array<DataImportFileType>;
    tags?: Array<string>;
    status?: DataImportStatus;
    startDate?: Date;
    endDate?: Date;
    sortDirection?: SortDirection;
    maxResults?: number;
    xClientID?: string;
    xRequestID?: string;
}

/**
 * 
 */
export class DataIngestionStatusApi extends runtime.BaseAPI {

    /**
     * Get an import wth the given ID
     */
    async getImportRaw(requestParameters: GetImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DataImport>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getImport().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getImport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:imports"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/data-ingestion-status/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DataImportFromJSON(jsonValue));
    }

    /**
     * Get an import wth the given ID
     */
    async getImport(requestParameters: GetImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DataImport> {
        const response = await this.getImportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get details for a completed import
     */
    async getImportDetailsRaw(requestParameters: GetImportDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DataImportRow>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getImportDetails().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getImportDetails().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['changeType'] != null) {
            queryParameters['changeType'] = requestParameters['changeType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:imports"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/data-ingestion-status/{id}/details`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DataImportRowFromJSON));
    }

    /**
     * Get details for a completed import
     */
    async getImportDetails(requestParameters: GetImportDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DataImportRow>> {
        const response = await this.getImportDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all tags created through imports
     */
    async getImportTagsRaw(requestParameters: GetImportTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DataImportTagResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getImportTags().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:imports"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/data-ingestion-status/tags`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DataImportTagResponseFromJSON(jsonValue));
    }

    /**
     * Get all tags created through imports
     */
    async getImportTags(requestParameters: GetImportTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DataImportTagResponse> {
        const response = await this.getImportTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for data imports by fileName, and/or date.
     */
    async searchImportsRaw(requestParameters: SearchImportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DataImport>>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling searchImports().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['fileName'] != null) {
            queryParameters['fileName'] = requestParameters['fileName'];
        }

        if (requestParameters['fileTypes'] != null) {
            queryParameters['fileTypes'] = requestParameters['fileTypes'];
        }

        if (requestParameters['tags'] != null) {
            queryParameters['tags'] = requestParameters['tags'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sortDirection'] = requestParameters['sortDirection'];
        }

        if (requestParameters['maxResults'] != null) {
            queryParameters['maxResults'] = requestParameters['maxResults'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:imports"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/data-ingestion-status`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DataImportFromJSON));
    }

    /**
     * Search for data imports by fileName, and/or date.
     */
    async searchImports(requestParameters: SearchImportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DataImport>> {
        const response = await this.searchImportsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
